(function () {
  'use strict';

  if (window.__brocadeV11Bundle) return;
  window.__brocadeV11Bundle = true;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown(scope) {
    var bar = scope.querySelector('[data-brocade-countdown-end]');
    if (!bar) return;
    var endRaw = bar.getAttribute('data-brocade-countdown-end');
    if (!endRaw) return;
    var end = Date.parse(endRaw);
    if (Number.isNaN(end)) return;

    var dEl = bar.querySelector('[data-count-unit="days"]');
    var hEl = bar.querySelector('[data-count-unit="hours"]');
    var mEl = bar.querySelector('[data-count-unit="minutes"]');
    var sEl = bar.querySelector('[data-count-unit="seconds"]');

    function tick() {
      var now = Date.now();
      var ms = Math.max(0, end - now);
      var s = Math.floor(ms / 1000);
      var days = Math.floor(s / 86400);
      s -= days * 86400;
      var hours = Math.floor(s / 3600);
      s -= hours * 3600;
      var minutes = Math.floor(s / 60);
      s -= minutes * 60;
      if (dEl) dEl.textContent = String(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(minutes);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  function initCurriculumTabs(scope) {
    var root = scope.querySelector('.curriculum-tabs');
    if (!root || root.dataset.brocadeBound) return;
    root.dataset.brocadeBound = '1';
    var buttons = root.querySelectorAll('.curriculum-tab-btn');
    var panels = root.querySelectorAll('.curriculum-tab-content');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var level = btn.getAttribute('data-level');
        buttons.forEach(function (b) {
          b.classList.toggle('active', b === btn);
        });
        panels.forEach(function (p) {
          p.classList.toggle('active', p.id === 'level-' + level);
        });
      });
    });
  }

  function initDetailTabs(scope) {
    var root = scope.querySelector('.detail-tabs-section');
    if (!root || root.dataset.brocadeBound) return;
    root.dataset.brocadeBound = '1';
    var buttons = root.querySelectorAll('.detail-tab-btn');
    var panels = root.querySelectorAll('.detail-tab-content');

    function activateTab(tab) {
      buttons.forEach(function (b) {
        var isActive = b.getAttribute('data-tab') === tab;
        b.classList.toggle('active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var panelTab = p.getAttribute('data-tab-panel');
        var match = panelTab === tab || p.id === 'tab-' + tab || (p.id && p.id.indexOf('tab-' + tab + '-') === 0);
        p.classList.toggle('active', match);
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(btn.getAttribute('data-tab'));
      });
    });
  }

  function initPricingCart(scope) {
    scope.querySelectorAll('[data-brocade-add-to-cart]').forEach(function (form) {
      if (form.dataset.brocadeCartBound) return;
      form.dataset.brocadeCartBound = '1';

      var idInput = form.querySelector('[data-variant-id-input]');

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = form.querySelector('[data-brocade-atc-btn]');
        var label = btn && btn.querySelector('.brocade-atc-btn__label');
        var originalText = label ? label.textContent : '';
        if (btn) btn.disabled = true;
        if (label) label.textContent = 'Adding…';

        var variantId = idInput ? idInput.value : null;
        if (!variantId) {
          alert('This option is not configured. Add a Variant ID in the theme editor.');
          if (btn) btn.disabled = false;
          if (label) label.textContent = originalText;
          return;
        }

        var cartApi = form.getAttribute('data-cart-api-url');
        if (!cartApi) {
          var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
          cartApi = root ? root + 'cart/add.js' : '/cart/add.js';
        }
        fetch(cartApi, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function () {
            var action = form.getAttribute('data-redirect') || 'cart';
            if (action === 'checkout') {
              window.location.href = '/checkout';
            } else if (action === 'cart') {
              window.location.href = '/cart';
            } else if (label) {
              label.textContent = 'Added ✓';
              setTimeout(function () {
                label.textContent = originalText;
                if (btn) btn.disabled = false;
              }, 2000);
            }
          })
          .catch(function (err) {
            var msg = (err && err.description) ? err.description : 'Could not add to cart. Please try again.';
            alert(msg);
            if (btn) btn.disabled = false;
            if (label) label.textContent = originalText;
          });
      });
    });
  }

  function initPricingExcludeMarker(scope) {
    var listSelector = '.price-features-rich li, .price-card .price-features li';
    scope.querySelectorAll(listSelector).forEach(function (li) {
      if (li.dataset.excludeParsed) return;
      li.dataset.excludeParsed = '1';
      if (li.classList.contains('exclude')) return;

      var html = li.innerHTML || '';
      var text = (li.textContent || '').trim();
      var startsWithX = /^\s*(\[x\]|\[X\]|✕|✖)\s*/.test(text);
      var endsWithPipe = /\|\s*(<\/p>\s*)?$/i.test(html) || /\|\s*$/.test(text);
      var hasItalic = li.querySelector('em') !== null;
      if (!endsWithPipe && !hasItalic && !startsWithX) return;

      li.classList.add('exclude');
      li.innerHTML = html
        .replace(/^\s*(\[x\]|\[X\]|✕|✖)\s*/i, '')
        .replace(/<p>\s*(\[x\]|\[X\]|✕|✖)\s*/i, '<p>')
        .replace(/\|\s*(<\/p>\s*)?$/i, '$1')
        .replace(/<\/?em>/gi, '');
    });
  }

  function getGap(track) {
    var styles = window.getComputedStyle(track);
    var g = parseFloat(styles.columnGap || styles.gap || '0');
    return Number.isFinite(g) ? g : 24;
  }

  function initHorizontalSliderOnTrack(track) {
    if (!track || track.dataset.brocadeSliderBound) return;
    track.dataset.brocadeSliderBound = '1';

    var wrap = track.closest('.slider-wrap');
    if (!wrap) return;
    var prev = wrap.querySelector('.slider-prev');
    var next = wrap.querySelector('.slider-next');
    var dotsRoot = wrap.parentElement ? wrap.parentElement.querySelector('.slider-dots') : null;
    if (!dotsRoot) dotsRoot = wrap.nextElementSibling;
    if (!dotsRoot || !dotsRoot.classList.contains('slider-dots')) dotsRoot = null;

    function cardStep() {
      var card = track.querySelector(':scope > *');
      if (!card) return track.clientWidth * 0.9;
      return card.getBoundingClientRect().width + getGap(track);
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth - 1);
    }

    function dotCount() {
      var step = cardStep();
      var max = maxScroll();
      if (step <= 0 || max <= 0) return 1;
      return Math.round(max / step) + 1;
    }

    function syncButtons() {
      var left = track.scrollLeft;
      var max = maxScroll();
      if (prev) prev.disabled = left <= 4;
      if (next) next.disabled = left >= max - 4;
      if (dotsRoot) {
        var step = cardStep();
        var idx = Math.min(Math.round(left / step), dotCount() - 1);
        var dots = dotsRoot.querySelectorAll('.slider-dot');
        dots.forEach(function (d, i) {
          d.classList.toggle('active', i === idx);
        });
      }
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () {
      scrollByDir(-1);
    });
    if (next) next.addEventListener('click', function () {
      scrollByDir(1);
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(syncButtons);
    });

    if (dotsRoot) {
      var n = dotCount();
      dotsRoot.innerHTML = '';
      for (var i = 0; i < n; i++) {
        (function (index) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'slider-dot' + (index === 0 ? ' active' : '');
          b.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: index * cardStep(), behavior: 'smooth' });
          });
          dotsRoot.appendChild(b);
        })(i);
      }
    }

    syncButtons();

    window.addEventListener('resize', function () {
      if (dotsRoot) {
        var count = dotCount();
        var currentDots = dotsRoot.querySelectorAll('.slider-dot').length;
        if (currentDots !== count) {
          track.dataset.brocadeSliderBound = '';
          initHorizontalSliderOnTrack(track);
        } else {
          syncButtons();
        }
      }
    });
  }

  function initAll(root) {
    var scopes = root.querySelectorAll('.brocade-v11-scope');
    if (!scopes.length && root.classList && root.classList.contains('brocade-v11-scope')) {
      scopes = [root];
    }
    scopes.forEach(function (scope) {
      initCountdown(scope);
      initCurriculumTabs(scope);
      initDetailTabs(scope);
      initPricingCart(scope);
      initPricingExcludeMarker(scope);
      scope.querySelectorAll('.slider-track').forEach(function (tr) {
        initHorizontalSliderOnTrack(tr);
      });
    });
  }

  function onReady() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) initAll(ev.target);
  });
})();
